<template>
    <v-toolbar dark color="#102d7c" height="92px;" class="toolbar">
    <v-toolbar-title>
        <v-btn text disabled>
        <img src="@/assets/ebm_logo.png" class="logo">
        </v-btn>
        <v-btn text :to="'/'" class="intro" >
        服務簡介
        </v-btn>
        <v-btn text :to="'/imageupload'" class="upload" >
        影像上傳
        </v-btn>
        <v-btn text @click="openebm" class="company">
        公司簡介
        </v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
        <v-btn icon @click="facebook" style="margin-right:5px">
            <img src="@/assets/medical_cd/facebook.png" class="social" >
        </v-btn>
        <v-btn icon @click="twitter" style="margin-right:5px">
            <img src="@/assets/medical_cd/twitter.png" class="social" >
        </v-btn>
        <v-btn icon @click="linkedin" style="margin-right:5px">
            <img src="@/assets/medical_cd/linkedin.png" class="social">
        </v-btn>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
              class="menu"
                dark
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :to="'/'">
                服務簡介
              </v-list-item>
              <v-list-item :to="'/imageupload'">
                影像上傳
              </v-list-item>
              <v-list-item @click="openebm">
                  公司簡介
              </v-list-item>
            </v-list>
          </v-menu>
    </v-toolbar-items>
    </v-toolbar>
</template>
<script>
export default {
    data(){
        return{
            sidebar:false
        }
    },
    methods: {
    openebm(){
            var url = 'http://www.ebmtech.com/index.php';
            var win = window.open(url, '_blank');
            win.focus();
        },
    facebook(){
        var url = 'https://www.facebook.com/ebmtech';
        var win = window.open(url, '_blank');
        win.focus();
    },
    twitter(){
            var url = 'https://twitter.com/EBM_Tech';
            var win = window.open(url, '_blank');
            win.focus();
        },
    linkedin(){
            var url = 'https://www.linkedin.com/company/ebmtech/';
            var win = window.open(url, '_blank');
            win.focus();
        },
  }
}
</script>
<style scoped>
.menu{
    display: none;
}
.social{
    width: 48px;
}
.company{
    font-size: 24px !important;
}
.logo{
    height:62px;
     width:208px;
}
.intro{
    font-size: 24px !important;
    margin-right: 80px;
    margin-left: 32px;
}
.upload{
    font-size: 24px !important;
    margin-right:80px
}
@media (max-width: 1398px) {
.intro{
    margin-right: 60px;
    margin-left: 22px;
}
.upload{
    margin-right:60px
}
}
@media (max-width: 990px){
    .intro{
    margin-right: 20px;
    margin-left: 12px;
    font-size: 20px !important;
}
.upload{
    margin-right:20px;
    font-size: 20px !important;
}
.company{
    font-size: 20px !important;
}
.social{
    width: 38px;
}
.logo{
    height: 52px;
    width: 168px;
}
}
@media (max-width: 809px){
 .intro{
   display: none;
}
.upload{
    display: none;
}
.company{
    display: none;
}
.menu{
    display: block;
}
}
@media (max-width: 435px){
    .social{
        width:22px;
        float: right;
    }
    .logo{
    height: 32px;
    width: 108px;
    margin-top: 3px;
}
/* .toolbar{
    height: 72px !important;
}
.v-toolbar__content{
    height: 72px !important;
} */
}
</style>
